import React from "react";
import { Modal, Input, Form, InputNumber } from "antd";
import { observer } from "mobx-react";
import { bannerEditStore } from "../../store/content/banner/BannerEditStore";

export const EduShareOfferBannerDlg = observer(({ onDone }) => {
  const [form] = Form.useForm();

  const save = () => {
    form.validateFields().then((values) => {
      bannerEditStore.save(values).then(() => {
        onDone && onDone();
      });
    });
  };

  const layout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 14 },
  };

  return (
    <Modal
      title="EduShare Offer Promote"
      visible={bannerEditStore.visible}
      maskClosable={false}
      destroyOnClose
      onOk={save}
      confirmLoading={bannerEditStore.saving}
      onCancel={() => bannerEditStore.close()}
    >
      <Form form={form} {...layout} initialValues={{ ...bannerEditStore.model }}>
        <Form.Item
          label="Title"
          name={["eduShareOffer", "title"]}
          rules={[{ required: true, message: "Please input title!" }]}
        >
          <Input placeholder="Enter title" />
        </Form.Item>
        <Form.Item
          label="Summary(up to 3 short lines)"
          name={["eduShareOffer", "summary"]}
          rules={[{ required: true, message: "Please input summary!" }]}
        >
          <Input.TextArea placeholder="Enter summary" rows={3} />
        </Form.Item>
        <Form.Item
          label="Price"
          name={["eduShareOffer", "price"]}
          rules={[{ required: true, message: "Please input price!" }]}
        >
          <InputNumber placeholder="Enter price" />
        </Form.Item>
        <Form.Item label="Original Price (optional)" name={["eduShareOffer", "originalPrice"]}>
          <InputNumber placeholder="Enter price" />
        </Form.Item>
      </Form>
    </Modal>
  );
});
